export const testimonials = [
	{
		image: '/images/testimonials/marina-sanvicente/person.webp',
		author: 'Marina Sanvicente',
		quote:
			'Com a ajuda da Renata, encontrei a cobertura dos meus sonhos, no bairro que sempre quis morar, mas nunca achava algo que fosse a minha cara. Ela foi cuidadosa, certeira e alinhada aos meus desejos, fazendo tudo com leveza e sensibilidade. Realizar esse sonho com o olhar dela foi único e inesquecível.',
		propertyType: null,
		brokerName: 'Renata Castro',
		brokerImage: '/images/testimonials/marina-sanvicente/broker.webp',
		companyName: 'Oásis Urbanos',
		companyImage: '/images/testimonials/marina-sanvicente/company.webp'
	},
	{
		image: '/images/testimonials/silvia-berger/person.webp',
		author: 'Silvia Berger',
		quote:
			'Sabrina mudou minha visão sobre corretores. Com foco nas necessidades do cliente, dados de mercado e feedback dos visitantes, ela vendeu meu apartamento em poucos meses após mais de um ano sem sucesso.',
		propertyType: null,
		brokerName: 'Sabrina Lapyda',
		brokerImage: '/images/testimonials/silvia-berger/broker.webp',
		companyName: 'Mosaic Homes',
		companyImage: '/images/testimonials/silvia-berger/company.webp'
	},
	{
		image: '/images/testimonials/horacio-ferreira/person.webp',
		author: 'Horácio Ferreira',
		quote:
			'Trabalhar com a Open Imóveis foi a melhor escolha! Conhecemos o André e o Matheus por indicação, e o profissionalismo deles fez toda a diferença. Com muita pesquisa e apoio da rede Pilar, tivemos confiança para fechar um ótimo negócio!',
		propertyType: null,
		brokerName: 'André Sarubbi',
		brokerImage: '/images/testimonials/horacio-ferreira/broker.webp',
		companyName: 'Open Imóveis',
		companyImage: '/images/testimonials/horacio-ferreira/company.webp'
	},
	{
		image: '/images/testimonials/adriana-ribarolli-parizotto/person.webp',
		author: 'Adriana Ribarolli Parizotto',
		quote:
			'Um amigo me apresentou o Edu como especialista na Vila Nova Conceição, e ele realmente é. Formado em direito, com vasto conhecimento imobiliário, é objetivo, assertivo e dedicado. Já fizemos negócios juntos, e ele sempre entrega com competência e alinhamento. Recomendo!',
		propertyType: null,
		brokerName: 'Eduardo Pontes',
		brokerImage: '/images/testimonials/adriana-ribarolli-parizotto/broker.webp',
		companyName: 'Eduardo Pontes',
		companyImage:
			'/images/testimonials/adriana-ribarolli-parizotto/company.webp'
	}
];
